// src/pages/Home.js
import AboutUs from './componentes/homepage/AboutUsSection/aboutus';
import Sponsor from './componentes/homepage/SponsorSection/Sponsor';
import NavBar from './componentes/homepage/Navbar/navbar';
import RobotShowcase from './componentes/homepage/robot/robot';
import Season from './componentes/homepage/SeasonsSection/season';
import Competidores from './componentes/homepage/Competitor/competitor';
import Quote from './componentes/homepage/QuoteSection/quote';
import SteamSection from './componentes/homepage/Steam/SteamSection';
import React, {useState, useEffect} from 'react';
import steam1 from './assets/Steam1.jpg';
import steam2 from './assets/Steam2.jpeg';
import steam3 from './assets/Steam3.jpeg';
import steam4 from './assets/Steam4.jpeg';
import steam5 from './assets/Steam5.jpeg';
import steam6 from './assets/Steam6.png';
import steam7 from './assets/temporadas/submerged/equipe2025/amistoso1.jpg';
import steam8 from './assets/temporadas/submerged/equipe2025/amistoso2.jpg';
import steam9 from './assets/temporadas/submerged/equipe2025/amistoso3.jpg';
import './App.css'; // Certifique-se que o CSS está sendo importado corretamente
// Suas importações de imagens
import ESub from "./assets/temporadas/submerged/Dnabots.jpg";
import Eune from "./assets/temporadas/unearthed/Eune.jpg";
import Emaster from "./assets/temporadas/masterpiece/EquipeMasterpiece.jpeg";
import Winners from "./assets/temporadas/submerged/classificacao.jpg"
import Margarida from "./assets/patrocinadores/escola/escola.png"



// import { useNavigate } from 'react-router-dom';
function Home() {
  const imagens = [
    steam1,
    steam2,
    steam3,
    steam4,
    steam5,
    steam6,
    steam7,
    steam8,
    steam9
  ];

  const [indice, setIndice] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setFade(false); // inicia transição
      setTimeout(() => {
        setIndice((prev) => (prev + 3) % imagens.length);
        setFade(true); // aplica nova transição
      }, 500); // tempo da transição
    }, 5000);

    return () => clearInterval(intervalo);
  }, [imagens.length]);

  const imagensVisiveis = [
    imagens[indice],
    imagens[(indice + 1) % imagens.length],
    imagens[(indice + 2) % imagens.length]
  ];
/*****************************************************************************************/ 

  return (
    <div className="App">
      <NavBar />
      <section className="img-section">
        <img className="background-img img1" src={ESub} alt="Equipe DNA Bots em competição submerged 2024" />
        <img className="background-img img2" src={Eune} alt="Equipe DNA Bots na competição amistosa submerged com novos membros da equipe 2025" />
        <img className='background-img img3' src={Emaster} alt="primeira versão da equipe DNA Bots na temporada masterpiece 2023"></img>

        <div className="overlay">
          <h1 className="title">DNA <span>BOTS</span></h1>
          <p className="slogan">“A robótica está no nosso DNA!”</p>
        </div>
      </section>

      <AboutUs />
      <SteamSection />
      <div className="hero-section">
        <div className="hero-title">
          <span className="first">FIRST</span> <span className="lego-league">LEGO League</span>
        </div>
        <div className="hero-content">
          <div className="hero-image-container">
            <img src={Winners} alt="Equipe Amigos Droids FLL" className="hero-image" />
          </div>
          <div className="hero-text-container">
            <p className="mb-6">
              Em pouco tempo de existência, a DNA BOT’S mostrou que determinação e trabalho em equipe são capazes de alcançar grandes feitos. Com uma trajetória inspiradora, conquistamos resultados que nos enchem de orgulho:
            </p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>3º lugar em Core Values – Temporada Masterpiece 2023/2024</li>
              <li>Classificação para a etapa nacional – Temporada Submerged 2024</li>
              <li>1º lugar geral – Torneio Amistoso Cidade dos Meninos 2025</li>
              <li>Prêmio Core Values – Torneio Amistoso SESI Betim 2024</li>
            </ul>
            <p>
              Agora, em 2025, iniciamos um novo capítulo. E pela primeira vez, decidimos compartilhar com o mundo os materiais que desenvolvemos ao longo da nossa jornada na FLL. Explore nossos projetos, estratégias e aprendizados — e inspire-se com tudo o que a DNA BOT’S viveu até aqui.
            </p>
          </div>
        </div>
      </div>
      <section>
        <div className='school'>
          <h3>Nossa escola:</h3>
          <img src={Margarida}></img>
        </div>

        <div className='school'>
          <h3>Nossos patrocinadores:</h3>
          <p className='sponsor'>Seja o primeiro patrocinador!</p>
        </div>
      </section>
      <Sponsor />
      <Season />


      <Competidores />
      <RobotShowcase />

      <section className="social-section">
        <div className="left">
          <h2>Novidades nas redes!</h2>
          <p>
            Siga nossas redes sociais para ficar por dentro das novidades e acompanhar tudo o que acontece. Elas também são um canal direto para você entrar em contato conosco de forma rápida e prática.
          </p>
          <div className="social-icons">
            <a href="https://www.instagram.com/dna_bots" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@dnabots" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=DmwnWrRpccnBXftqVsZRxCJLMdRwvjCzhBHPVHDlPdjPznLNZSjKQwpvMSBBRxKvDWBDJtfhDpZq" target="_blank">
              <i className="fas fa-envelope"></i>
            </a>
          </div>
        </div>

        <div className="right">
          <div className="media-container">
            <div className="widget-container">
              <script src="https://static.elfsight.com/platform/platform.js" async></script>
              <div
                className="elfsight-app-f97e576a-0659-433d-83ca-8249586fad71"
                data-elfsight-app-lazy
              ></div>
            </div>
          </div>
        </div>
      </section>
      <Quote />

      <section className='support'>
        <div className='supporter'>
          <h4>Apoiadores:</h4>
          <p className='p_sup'>Seja o primeiro apoiador!</p>
        </div>
        <div>
          <p>DNA Bots | Escola Municipal Margarida Soares Guimarães </p>
          <p>R. Tocantins, 335 - Brasiléia, Betim - MG</p>
        </div>
        <div className="social-icons">
          <a href="https://www.instagram.com/dna_bots" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.tiktok.com/@dnabots" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-tiktok"></i>
          </a>
          <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=DmwnWrRpccnBXftqVsZRxCJLMdRwvjCzhBHPVHDlPdjPznLNZSjKQwpvMSBBRxKvDWBDJtfhDpZq" target="_blank">
            <i className="fas fa-envelope"></i>
          </a>
        </div>
      </section>



    </div>
  );
}

export default Home;